// @ts-nocheck
import { Trans } from '@lingui/react'
import { FC, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import './RedeemRedPoints.scss'
import { CartControllerRedPointsPossibleDiscountsV2 } from 'types/api/cart'
import { mountSelect } from 'views/assets/scripts/select'
import Notification, {
  NOTIFICATION_TYPES,
} from 'views/components/molecules/Notification'
import { redeemedRedPointsSelector } from 'views/components/organisms/Cart/selectors'

import Information from './Information'
import RedPointsSelect from './RedPointsSelect'
import RedPointsSubmitButton from './RedPointsSubmitButton'

interface RedeemRedPointsProps {
  redPointsInCustomerAccount: number
  redPointsPossibleDiscounts: CartControllerRedPointsPossibleDiscountsV2[]
  hasSAEGroup: boolean
  isMixedGroup: boolean
  hasERx: boolean
}

const RedeemRedPoints: FC<RedeemRedPointsProps> = ({
  redPointsInCustomerAccount = 0,
  redPointsPossibleDiscounts = [],
  hasSAEGroup = true,
  isMixedGroup = false,
  hasERx = false,
}) => {
  const redPointsPreviousAmount =
    Number(useSelector(redeemedRedPointsSelector)) * 1000

  const redPointsPossibleDiscountsWithDefault = [
    {
      pointsToRedeem: 0,
      discountCents: 0,
    },
    ...redPointsPossibleDiscounts.sort(
      (a, b) => a.discountCents - b.discountCents
    ),
  ]

  const minPossibleDiscount = Math.min(
    ...redPointsPossibleDiscountsWithDefault.map(
      discount => discount.pointsToRedeem
    )
  )

  const maxPossibleDiscount = Math.max(
    ...redPointsPossibleDiscountsWithDefault.map(
      discount => discount.pointsToRedeem
    )
  )

  const [selectedRedPoints, setSelectedRedPoints] = useState<number>(
    redPointsPreviousAmount || minPossibleDiscount
  )

  // The maximum possible redpoints to redeem can change, for instance if a user
  // removes a product from his or her cart. In this case not only the options of the
  // Select must change but also the initially selected amount of red points, which
  // will be sent to the backend eventually.
  useEffect(() => {
    if (selectedRedPoints > maxPossibleDiscount) {
      setSelectedRedPoints(minPossibleDiscount)
    }
  }, [selectedRedPoints, maxPossibleDiscount, minPossibleDiscount])

  const hasDiscounts = redPointsPossibleDiscounts.length > 0

  const redeemRedPointsRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (redeemRedPointsRef.current) {
      mountSelect(redeemRedPointsRef.current)
    }
  }, [])

  return (
    <div
      ref={redeemRedPointsRef}
      id="redeemRedPoints"
      className="o-RedeemRedPoints"
    >
      <div className="o-RedeemRedPoints__input-row u-margin-large--bottom l-flex">
        <RedPointsSelect
          hasDiscounts={hasDiscounts}
          selectedRedPoints={selectedRedPoints}
          redPointsDiscounts={redPointsPossibleDiscountsWithDefault}
          onChange={value => setSelectedRedPoints(parseInt(value))}
        />

        <RedPointsSubmitButton
          selectedRedPoints={selectedRedPoints}
          redPointsPreviousAmount={redPointsPreviousAmount}
          hasSAEGroup={hasSAEGroup}
        />
      </div>
      {(!hasSAEGroup || isMixedGroup || hasERx) && (
        <div className="u-margin--bottom o-Cart__RedeemRedPoints__notification">
          <Notification
            label={
              <Trans id="checkout.verification.redPointsModal.descriptionTextForRedPointsProducts" />
            }
            type={NOTIFICATION_TYPES.INFO}
            dataQaId="cart-redPointsBox-notification"
          />
        </div>
      )}
      <Information
        hasDiscounts={hasDiscounts}
        redPointsInCustomerAccount={redPointsInCustomerAccount}
      />
    </div>
  )
}

export default RedeemRedPoints
